export default __webpack_public_path__ + "static/media/logo-dark.a84c24f5.png";